'use client'
import { useRouter } from "next/navigation";
import { ReactNode } from "react";

export function BuilderWrapper({ children }: { children: ReactNode}) {
    const router = useRouter()
    return (
        <div onClick={(e) => {
            const target = e.target as HTMLElement
            if ((e.target as HTMLElement).tagName === "A" || target.closest("a")) {
                e.preventDefault()
                const regex = /^(https:\/\/)?(www\.)?frontpointsecurity\.com\/shop\/([^\/]+)$/;
                const match = target.closest("a")?.getAttribute("href")?.match(regex);
                if (match) {
                    router.push(`/products-modal/${match[3]}`, { scroll: false })
                }
            }
        }}>
            {children}
        </div>
    );
}